export default "__VITE_ASSET__2975010a__"